import { t } from "../../../services/utils";
import React from "react";
import {
  primaryDark10,
  grey600,
  primaryDark,
  primaryDark80,
} from "../../../constants/colors";
import Icon from "@material-ui/core/Icon";
import { calculateTextHeight } from "../../../services/utils";
class MealDetailView extends React.Component {
  constructor(props) {
    super(props);
  }
  render = () => {
    let styles = {
      container: {
        height: "100%",
        backgroundColor: "white",
        display: "flex",
        // paddingLeft: 16,
        // paddingRight: 16,
        flexDirection: "column",
        borderLeft: "1px solid #EAE9EF",
        borderRight: "1px solid #EAE9EF",
      },
      progressCell: {
        width: 60,
        height: 60,
        marginLeft: 10,
        backgroundColor: primaryDark10,
        borderRadius: 2,
        position: "relative",
      },
      period: {
        color: "#2A234E",
        fontSize: 16,
        textAlign: "left",
        width: "45%",
        // borderBottom: "1px solid #e6e6e6",
        display: "flex",
        alignItems: "center",
      },
      progress: {
        fontSize: 16,
        color: "#2A234E",
        width: "45%",
        textAlign: "left",
        // borderBottom: "1px solid #e6e6e6",
        display: "flex",
        alignItems: "center",
      },
      row: {
        display: "flex",
        width: "calc(100% - 32px)",
        alignItems: "center",
        marginTop: 10,
        paddingLeft: 16,
        paddingRight: 16,
        // borderBottom: "1px solid #e6e6e6",
        // height: 35
      },

      column: {
        width: "8%",
        display: "inline-block",
        alignItems: "flex-end",
        flexDirection: "row",
        marginRight: 5,
        fontSize: 14,
        color: primaryDark80,
        fontWeight: "500",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      },
      header: {
        fontSize: 13,
        color: "#524D70",
        // paddingBottom: 5,
      },

      columnlg: {
        width: "48%",
      },
      columnmd: {
        width: "16%",
      },
      type: {
        fontSize: 16,
        fontWeight: "500",
        color: primaryDark,
        // textTransform: "uppercase",
        // marginTop: 10,
      },

      mealTypeContainer: {
        borderBottom: "1px solid #EAE9EF",
        paddingBottom: 10,
      },
      total: {
        marginTop: 5,
      },
      totalCal: {
        color: "#2A234E",
        fontWeight: "bold",
        marginTop: 5,
        paddingBottom: 0,
      },
    };
    const { mts, meta } = this.props;
    const { gc, gpr, gfa, gca } = meta;
    let hasGoal;
    if (gc == null) {
      hasGoal = false;
    } else {
      hasGoal = true;
    }
    return (
      <div style={styles.container}>
        <div
          style={{
            ...styles.row,
            ...{
              borderBottom: "1px solid #EAE9EF",
              marginTop: 0,
              paddingTop: 5,
              paddingBottom: 5,
            },
          }}
        >
          <div
            style={{
              ...styles.column,
              ...styles.header,
              ...styles.columnlg,
            }}
          >
            {t("eating")}
          </div>
          <div
            style={{
              ...styles.column,
              ...styles.header,
              ...styles.columnmd,
            }}
          >
            {t("serving")}
          </div>
          <div
            style={{
              ...styles.column,
              ...styles.header,
            }}
          >
            {t("carbs")}
          </div>
          <div
            style={{
              ...styles.column,
              ...styles.header,
            }}
          >
            {t("protein")}
          </div>
          <div
            style={{
              ...styles.column,
              ...styles.header,
            }}
          >
            {t("fats")}
          </div>
          <div
            style={{
              ...styles.column,
              ...styles.header,
            }}
          >
            {t("calories")}
          </div>
        </div>
        {mts.map((type) => {
          return (
            meta[type[0]].length > 0 && (
              <div key={`ml-${type[0]}`} style={styles.mealTypeContainer}>
                <div style={styles.row}>
                  <div
                    style={{
                      ...styles.column,
                      ...styles.columnlg,
                    }}
                  >
                    <div style={styles.type}>{type[1]}</div>
                  </div>
                </div>
                {meta[type[0]].length > 0 &&
                  meta[type[0]].map((entry, i) => {
                    return (
                      <div key={`ml-de-${i}`} style={styles.row}>
                        <div
                          style={{
                            ...styles.column,
                            ...styles.columnlg,
                          }}
                        >
                          {entry.na}
                        </div>
                        <div
                          style={{
                            ...styles.column,
                            ...styles.columnmd,
                          }}
                        >
                          {entry.se}
                        </div>
                        <div style={styles.column}>{entry.ca}</div>
                        <div style={styles.column}>{entry.pr}</div>
                        <div style={styles.column}>{entry.fa}</div>
                        <div style={styles.column}>{entry.cl}</div>
                      </div>
                    );
                  })}
              </div>
            )
          );
        })}

        {hasGoal && (
          <div
            style={{
              ...styles.row,
              ...{
                marginTop: 10,
                justifyContent: "space-between",
                paddingTop: 10,
                paddingBottom: 10,
              },
            }}
          >
            <div
              style={{
                ...styles.columnlg,
              }}
            >
              {t("goal")}
            </div>
            <div style={styles.columnmd}></div>
            <div
              style={{
                ...styles.column,
              }}
            >
              {gca}
            </div>
            <div
              style={{
                ...styles.column,
              }}
            >
              {gpr}
            </div>
            <div
              style={{
                ...styles.column,
              }}
            >
              {gfa}
            </div>
            <div
              style={{
                ...styles.column,
              }}
            >
              {gc}
            </div>
          </div>
        )}
        <div
          style={{
            ...styles.row,
            ...{
              marginTop: 0,
              justifyContent: "space-between",
              borderBottom: "1px solid #EAE9EF",
              paddingTop: 10,
              paddingBottom: 10,
            },
          }}
        >
          <div
            style={{
              ...styles.total,
              ...styles.columnlg,
            }}
          >
            {t("total")}
          </div>
          <div style={styles.columnmd}></div>
          <div
            style={{
              ...styles.totalCal,
              ...styles.column,
            }}
          >
            {meta.tca}
          </div>
          <div
            style={{
              ...styles.totalCal,
              ...styles.column,
            }}
          >
            {meta.tpr}
          </div>
          <div
            style={{
              ...styles.totalCal,
              ...styles.column,
            }}
          >
            {meta.tfa}
          </div>
          <div
            style={{
              ...styles.column,
              ...styles.totalCal,
            }}
          >
            {meta.t}
          </div>
        </div>
      </div>
    );
  };
  static getHeight(props) {
    const { mts, meta } = props;
    const { gc } = meta;
    let hasGoal;
    if (gc == null) {
      hasGoal = false;
    } else {
      hasGoal = true;
    }
    let numRows = 0;
    let totalRowHeight = 0;
    let totalMealTypeHeight = 0;
    let goalMealTypeHeight = 0;
    let height = 0;
    for (let i = 0; i < mts.length; i++) {
      let entries = meta[mts[i][0]];
      if (entries.length > 0) {
        for (let j = 0; j < entries.length; j++) {
          let entry = entries[j];
          let seHeight = calculateTextHeight(entry.se, 110, {
            fontSize: 16,
          });
          let naHeight = calculateTextHeight(entry.na, 350, {
            fontSize: 16,
          });
          let rowHeight = Math.max(seHeight, naHeight) + 10; // adding margintop of row
          totalRowHeight += rowHeight;
        }
        totalMealTypeHeight += 30 + 10 + 10; // font height + margin top + margin top
        numRows += entries.length;
      }
    }
    if (hasGoal) {
      goalMealTypeHeight += 20 + 10 + 10; // font height + margin top + margin top
    }

    height =
      height +
      totalRowHeight +
      goalMealTypeHeight +
      totalMealTypeHeight +
      33 +
      60 +
      10; // adding header height and footer height plus extra height
    return height;
  }
}
export default MealDetailView;
